import { Button, Chip, Stack } from '@mui/material';
import { TOrganisationCodeWorkflowType } from './OrganisationCodeWorkflowSwitcher';

export interface WorkflowButtonProps {
  workflow: TOrganisationCodeWorkflowType;
  isSelected: boolean;
  label: string;
  onClick: (workflow: TOrganisationCodeWorkflowType) => void;
  disabled?: boolean;
}

export default function WorkflowButton({
  workflow,
  isSelected,
  label,
  onClick,
  disabled = false,
}: Readonly<WorkflowButtonProps>) {
  return (
    <Stack alignItems="center" justifyContent="center">
      <Stack
        sx={(theme) => ({
          minHeight: theme.semantic.size['6xs'],
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: theme.semantic.spacing.xs,
        })}
      >
        {isSelected && <Chip label="Current Workflow" color="primary" size="small" />}
      </Stack>
      <Button
        variant={isSelected ? 'contained' : 'outlined'}
        fullWidth
        disableRipple
        disabled={disabled}
        aria-pressed={isSelected}
        data-action={`select-workflow-${workflow.toLowerCase().replaceAll('_', '-')}`}
        sx={(theme) => ({
          padding: `${theme.semantic.spacing.xs} ${theme.semantic.spacing.base}`,
          minHeight: theme.semantic.spacing['6xl'],
        })}
        onClick={() => onClick(workflow)}
      >
        {label}
      </Button>
    </Stack>
  );
}
